import React, {useState, Component, useEffect} from 'react';
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBSpinner,
    MDBAlert, MDBCol
} from 'mdbreact';
import * as List from "../../../Utils/FunctionList";
import classes from './ReportModal.module.css'
import {Trans} from "react-i18next";
import firebase from "../../../Config/firebase";
const db = firebase.firestore()

const ReportModal = (props) => {

    const [submitting, setSubmitting] = useState(false)
    const [problem, setProblem] = useState({
        content:"",
        createDate: new Date(),
        isFinish: false,
        itemID: "",
        url:""
    })

    useEffect(() => {
        setProblem({
            ...problem,
            itemID:props.metadata.itemID,
            url: window.location.pathname
        })
    },[])

    const submitReport = () => {
        console.log(problem)
        setSubmitting(true)
        db.collection("Problem")
            .add(problem)
            .then(docs => {
                setSubmitting(false)
                setProblem({
                    content:"",
                    createDate: new Date(),
                    isFinish: false,
                    itemID: "",
                    url:""
                })
                props.setModalController({type :List.SUPPORTED_FUNCTIONS.CLOSE_MODAL })
            })
            .catch(err => console.log(err))
    }

    return (
        <MDBModal isOpen={true}>
            <MDBModalHeader>
                <Trans>ReportModal.report</Trans> {window.pathname}
            </MDBModalHeader>
            <MDBModalBody>
                <MDBAlert color={"danger"} className={classes.Alert}>
                    <Trans>CategoryPage.chinese-url</Trans>
                </MDBAlert>
                  <textarea className={classes.Description}
                            placeholder={'說明你的問題'}
                            disabled={submitting}
                            value={problem.content}
                            onChange={(e) => {
                                setProblem({
                                    ...problem,
                                    content: e.target.value
                                })
                            }}
                  />
            </MDBModalBody>
            <MDBModalFooter>
                <button className={classes.CloseBtn} onClick={() => props.setModalController({type :List.SUPPORTED_FUNCTIONS.CLOSE_MODAL })}>
                    <Trans>ReportModal.close</Trans>
                </button>
                <button className={classes.SubmitBtn} onClick={() => submitReport()} >
                    {submitting ? <MDBSpinner/> :  <Trans>ReportModal.submit</Trans>}
                </button>
            </MDBModalFooter>
        </MDBModal>
    );

}

export default ReportModal;